/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,ShimmerButton,ShimmerTitle,ShimmerThumbnail, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

function OfferSkeletonCard() {
    return (
        <div className='pb-5 pt-8'>{[...Array(5)].map((val)=>(
            <div className="" key={val}>
                <div className="w-full rounded-[10px] shadow-s7 p-2.5 mb-2" >
                    <div className="relative ">
                        <ul className="flex justify-end items-center sm:flex-col flex-row">
                            <li>
                                <button type="button" className="text-xs font-semibold text-[#FFFFFF]  rounded px-1.5 py-1 w-fit absolute right-12 top-2"><ShimmerBadge width={80}/></button>
                            </li>
                            <li>
                                <button type="button" className="text-xs font-semibold text-[#FFFFFF]  rounded px-1.5 py-1 w-fit absolute right-2 top-2"><ShimmerBadge width={80}/></button>
                            </li>
                        </ul>
                        <div className="">
                            <div className="flex items-center justify-between mt-5 lg:flex-nowrap flex-wrap">
                                <div className="flex items-center sm:flex-nowrap flex-wrap">
                                    <ShimmerCircularImage size={80}/>
                                    <div className="pl-5 w-full">
                                        <ul className="sm:mt-0 mt-2">
                                            <li className="font-semibold text-base text-[#090406]"><ShimmerBadge width={140}/></li>
                                            <li className="text-[#44445E] font-normal text-xs13 my-[7px]"><ShimmerBadge width={100}/><span className="px-2"></span><ShimmerBadge width={80}/><span className="px-2"></span></li>
                                            <li className="text-[#44445E] font-normal text-xs2"><ShimmerText line={2} gap={10} /></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="flex items-center justify-end lg:mt-10 mt-5 sm:ml-0 ml-5">
                                    <button type="button" className="sm:w-[284px] w-[170px] h-10 rounded-lg font-semibold text-sm text-[#FFFFFF]">
                                        <ShimmerButton/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}</div>
    )
}

export default OfferSkeletonCard